import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, PackageCheck, Home } from 'lucide-react';
import type { DashboardMetrics } from '../utils/calculations';
interface DeliveryFunnelProps {
  metrics: DashboardMetrics;
}
export function DeliveryFunnel({
  metrics
}: DeliveryFunnelProps) {
  const funnelSteps = [{
    label: 'Pedidos',
    value: metrics.funnelOrders,
    percentage: '100%',
    icon: ShoppingCart,
    color: 'bg-cyber-green'
  }, {
    label: 'Enviados',
    value: metrics.funnelShipped,
    percentage: `${metrics.funnelShipped}%`,
    icon: PackageCheck,
    color: 'bg-white'
  }, {
    label: 'Entregados',
    value: metrics.funnelDelivered,
    percentage: `${metrics.funnelDelivered}%`,
    icon: Home,
    color: 'bg-salmon'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.4
  }} className="glass-card p-6 md:p-8" data-id="element-55">
      <h2 className="text-sm font-bold tracking-widest text-white/70 uppercase mb-8 text-center" data-id="element-56">
        Embudo de Efectividad
      </h2>

      <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0 relative" data-id="element-57">
        {/* Connecting Line (Desktop) */}
        <div className="hidden md:block absolute top-1/2 left-[10%] right-[10%] h-0.5 bg-white/10 -translate-y-1/2 z-0" data-id="element-58"></div>

        {funnelSteps.map((step, index) => <Fragment key={index} data-id="element-59">
            <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.5 + index * 0.2,
          type: 'spring'
        }} className="relative z-10 flex flex-col items-center w-full md:w-1/3" data-id="element-60">
              {/* Value Circle */}
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-full flex items-center justify-center bg-black border-2 border-white/10 shadow-lg relative group" data-id="element-61">
                <div className={`absolute inset-0 rounded-full opacity-20 blur-xl ${step.color} group-hover:opacity-40 transition-opacity`} data-id="element-62"></div>
                <div className="text-center relative z-10" data-id="element-63">
                  <span className="block text-2xl md:text-3xl font-black text-white" data-id="element-64">
                    {step.value}
                  </span>
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-black border border-white/20 flex items-center justify-center" data-id="element-65">
                  <step.icon className="w-4 h-4 text-white/70" data-id="element-66" />
                </div>
              </div>

              {/* Labels */}
              <div className="mt-4 text-center" data-id="element-67">
                <h3 className="text-sm font-bold text-white uppercase tracking-wider" data-id="element-68">
                  {step.label}
                </h3>
                <span className={`inline-block mt-1 px-2 py-0.5 rounded text-xs font-bold text-black ${step.color}`} data-id="element-69">
                  {step.percentage}
                </span>
              </div>
            </motion.div>

            {index < funnelSteps.length - 1 && <div className="md:hidden w-px h-8 bg-white/20 my-2" data-id="element-70"></div>}
          </Fragment>)}
      </div>
    </motion.div>;
}